@let currentLanguage = currentLanguage$ | async;

<dialog #_innerModal eclModal [variant]="'information'" size="full"
        (modalClose)="modalClose.emit($event)">
    <header eclModalHeader>
        {{ 'easeportal.terms-and-conditions-modal.TITLE' | translate }}
    </header>
    <div eclModalBody isScrollable>
        <p [innerHTML]="'easeportal.terms-and-conditions-modal.DESCRIPTION' | translate : {
                    reqLink: 'https://www.ec.europa.eu/transparency/documents-request',
                    privacyStatementLink: 'https://ec.europa.eu/info/principles-and-values/transparency/access-documents/privacy-statement_' + currentLanguage,
                    regulationLink: 'https://eur-lex.europa.eu/legal-content/' + currentLanguage + '/ALL/?uri=CELEX%3A32001R1049',
                    psLink: 'https://ec.europa.eu/info/principles-and-values/transparency/access-documents/privacy-statement_' + currentLanguage,
                    dprLink: 'https://eur-lex.europa.eu/legal-content/' + currentLanguage + '/TXT/?uri=CELEX%3A32018R1725'
                }">
        </p>
    </div>
</dialog>
